// Định nghĩa cột bảng bình luận (tách khỏi container để gọn file)
import React from "react";
import { Button, Space, Tag, Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faReply, faTrash, faExternalLink, faCheck } from "@fortawesome/free-solid-svg-icons";
import UserCell from "./user-cell";
import { fmtTime, postUrl } from "../helpers";

// onReplyToggle(commentId): bung/đóng hội thoại; onDelete(record): xóa bình luận;
// onApprove(record): duyệt bình luận đang chờ (status=0 -> 1)
export function buildCommentColumns({ onReplyToggle, onDelete, onApprove }) {
    // responsive: ["md"] — ẩn cột phụ trên điện thoại, giữ Người gửi/Nội dung/
    // Trạng thái/Hành động để duyệt được ngay trên màn hình hẹp
    return [
        { title: "ID", dataIndex: "commentId", key: "commentId", width: 60, responsive: ["md"] },
        {
            title: "Bài viết",
            key: "post",
            width: 160,
            responsive: ["md"],
            render: (_, r) => (
                <a
                    href={postUrl(r.postId, r.commentId)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:underline line-clamp-2 break-words"
                    title={r.post?.title || `#${r.postId}`}
                >
                    {r.post?.title || `#${r.postId}`}{" "}
                    <FontAwesomeIcon icon={faExternalLink} className="text-[10px]" />
                </a>
            ),
        },
        { title: "Người gửi", key: "user", width: 170, render: (_, r) => <UserCell user={r.user} /> },
        {
            title: "Nội dung",
            dataIndex: "comment",
            key: "comment",
            width: 320,
            render: (val) => (
                <span className="text-content-2 line-clamp-2 break-words" title={val}>
                    {val}
                </span>
            ),
        },
        {
            title: "Trả lời",
            key: "replyCount",
            width: 80,
            align: "center",
            responsive: ["md"],
            render: (_, r) => (
                <Tag color={r.replies?.length ? "blue" : "default"}>{r.replies?.length || 0}</Tag>
            ),
        },
        {
            title: "Trạng thái",
            dataIndex: "status",
            key: "status",
            width: 110,
            align: "center",
            // status=0: chờ duyệt (spam-guard); 1 hoặc undefined (dữ liệu cũ): hiển thị.
            // Comment đã duyệt nhưng CÓ reply chờ duyệt -> tag cam để admin bung ra duyệt.
            render: (val, r) => {
                if (val === 0) return <Tag color="red">Chờ duyệt</Tag>;
                const pendingReplies = (r.replies || []).filter((rp) => rp.status === 0).length;
                if (pendingReplies > 0)
                    return <Tag color="orange">{pendingReplies} reply chờ duyệt</Tag>;
                return <Tag color="green">Hiển thị</Tag>;
            },
        },
        { title: "Ngày", dataIndex: "createTime", key: "createTime", width: 120, render: fmtTime, responsive: ["md"] },
        {
            title: "Hành động",
            key: "action",
            width: 130,
            fixed: "right",
            render: (_, r) => (
                <Space size={4}>
                    {r.status === 0 && (
                        <Tooltip title="Duyệt bình luận (hiển thị công khai)">
                            <Button
                                size="small"
                                type="primary"
                                icon={<FontAwesomeIcon icon={faCheck} />}
                                onClick={() => onApprove(r)}
                            />
                        </Tooltip>
                    )}
                    <Tooltip title="Trả lời">
                        <Button
                            size="small"
                            type="primary"
                            ghost
                            icon={<FontAwesomeIcon icon={faReply} />}
                            onClick={() => onReplyToggle(r.commentId)}
                        />
                    </Tooltip>
                    <Tooltip title="Xóa bình luận">
                        <Button
                            size="small"
                            danger
                            icon={<FontAwesomeIcon icon={faTrash} />}
                            onClick={() => onDelete(r)}
                        />
                    </Tooltip>
                </Space>
            ),
        },
    ];
}
